import { Component } from '@angular/core';

@Component({
  selector: 'app-tokenomics',
  templateUrl: './tokenomics.component.html',
  styleUrl: './tokenomics.component.scss'
})
export class TokenomicsComponent {

  distribution = [
    {
      img: 'public',
      percent: '50',
      title: 'tokenomics.title1',
      desc: 'tokenomics.desc1',
      theme: 'green'
    },
    {
      img: 'lock',
      percent: '20',
      title: 'tokenomics.title2',
      desc: 'tokenomics.desc2',
      theme: 'cyan'
    },
    {
      img: 'up-trend',
      percent: '10',
      title: 'tokenomics.title3',
      desc: 'tokenomics.desc3',
      tokens: '1,000,000,000',
      theme: 'purple'
    },
    {
      img: 'share',
      percent: '10',
      title: 'tokenomics.title4',
      desc: 'tokenomics.desc4',
      tokens: '2,000,000,000',
      theme: 'blue'
    },
    {
      img: 'public',
      percent: '8',
      title: 'tokenomics.title5',
      desc: 'tokenomics.desc5',
      theme: 'tiye'
    },
    {
      img: 'user',
      percent: '2',
      title: 'tokenomics.title6',
      desc: 'tokenomics.desc6',
      theme: 'orange'
    }
  ]

  amounts = [
    {
      title: 'tokenomics.card1_title',
      desc: 'tokenomics.card1_desc',
      amount: '$459B',
    },
    {
      title: 'tokenomics.card2_title',
      desc: 'tokenomics.card2_desc',
      amount: '$96.39B',
    },
    {
      title: 'tokenomics.card3_title',
      desc: 'tokenomics.card3_desc',
      txt: 'tokenomics.card3_txt'
    },
    {
      title: 'tokenomics.card4_title',
      desc: 'tokenomics.card4_desc',
      txt: 'tokenomics.card4_txt'
    }
  ]

}
